// ignore-string-externalization

import { fetchCurrentUser } from '../../../@mrkt/useCurrentUser';
import { setState } from './root';

const key = 'me';

export const loadMe = () => async (dispatch: $TSFixMe) => {
  const me = await fetchCurrentUser();
  dispatch(
    setState({
      type: `${key}/LOAD`,
      payload: {
        [key]: me ? { ...me, loaded: true } : null,
      },
    }),
  );
};

export const selectMe = (state: $TSFixMe) => state[key];
